<template>
  <div class="home">
    <ButtonVcita/>
  </div>
</template>

<script>

import ButtonVcita from '@/components/Button.vue'

export default {
  name: 'home',
  components: { ButtonVcita }
}
</script>
